module.exports = __webpack_public_path__ + "static/media/uz.d9b78209.svg";